// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { backdropColors } from './backdropColors';
export var Backdrop = function(mode) {
    var c = backdropColors(mode);
    var override = {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: c.background
                },
                invisible: {
                    backgroundColor: 'transparent'
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Backdrop.js.map